// @flow
import * as React from 'react'

export function Property (props: { keyName: string, children: React.Node }) {
  return (
    <tr className={`property ${props.keyName.toLowerCase()}`}>
      <td className='title six wide'>{props.keyName}</td>
      <td className=''>{props.children}</td>
    </tr>
  )
}

export default Property



// WEBPACK FOOTER //
// ./src/components/property/index.js